<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>User Details</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">User Details</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <el-dropdown split-button :trigger="'click'"
                           @command="handleSelectedRows"
                           type="primary" v-if="this.selected_row.length" class="mr-1">
                {{ this.selected_row.length }} {{ 'item' | pluralize(this.selected_row.length) }} selected
                <!--                <el-dropdown-menu slot="dropdown">
                                  <el-dropdown-item command="delete">Delete Selected Items</el-dropdown-item>
                                </el-dropdown-menu>-->
              </el-dropdown>
              <button class="btn btn-info" type="button" @click="showFilter = !showFilter">
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>

            <div class="card-tools">
              <!--              <router-link :to="{ name: 'EWUserPendingDetailAdd'}" class="btn btn-success" v-if="actionCreate">
                              <i class="fas fa-plus"></i> New
                            </router-link>-->
              <button class="btn btn-info" @click="exportFile()">
                <i class="fas fa-download"></i> Export
              </button>

            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="username">Username</label>
                    <div class="col-md-9">
                      <input type="text" id="username" class="form-control"
                             v-model="filter.username"
                             placeholder="UserName">
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="username">Full Name</label>
                    <div class="col-md-9">
                      <input type="text" id="fullname" class="form-control"
                             v-model="filter.fullname"
                             placeholder="Full Name">
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="email">Email</label>
                    <div class="col-md-9">
                      <input type="text" id="email" class="form-control"
                             v-model="filter.email"
                             placeholder="Email">
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="nid_number">NID Number</label>
                    <div class="col-md-9">
                      <input type="text" id="nid_number" class="form-control"
                             v-model="filter.nid_number"
                             placeholder="NID Number">
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="step">Step</label>
                    <div class="col-md-9">
                      <input type="text" id="step" class="form-control"
                             v-model="filter.step"
                             placeholder="Step">
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="status">Status</label>
                    <div class="col-md-9">
                      <select class="form-control" style="width: 100%;" id="status" name="status"
                              v-model="filter.status">
                        <option value="approved">Approved</option>
                        <option value="pending">Pending</option>
                        <option value="hold">Hold</option>
                        <option value="rejected">Rejected</option>
                      </select>
                    </div>

                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="status">Country</label>
                    <div class="col-md-9">
                      <select class="form-control" @change="updateCityList" style="width: 100%;" id="country_id"
                              name="country_id"
                              v-model="filter.country_id">
                        <option v-for="(val, index) in countries" :value="val.value">{{ val.label }}</option>
                      </select>
                    </div>
                  </div>
                </div>


                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="status">City</label>
                    <div class="col-md-9">
                      <select class="form-control" style="width: 100%;" id="city_id" name="city_id"
                              v-model="filter.city_id">
                        <option v-for="(val, index) in cities" :value="val.value">{{ val.label }}</option>
                      </select>
                    </div>
                  </div>
                </div>


                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="gender">Gender</label>
                    <div class="col-md-9">
                      <select class="form-control" style="width: 100%;" id="gender" name="gender"
                              v-model="filter.gender">
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="created_at">Date range</label>
                    <div class="col-md-9">
                      <date-picker type="datetime" input-class="form-control" v-model="filter.created_at" range
                                   lang="en" format="YYYY-MM-DD" confirm id="created_at"
                                   value-type="YYYY-MM-DD"></date-picker>
                    </div>
                  </div>

                </div>

              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9">
                      <button type="submit" class="btn btn-common m-2px"><i class="fas fa-search"></i> Search</button>
                      <button type="reset" class="btn btn-warning" @click="resetFilter()"><i class="fas fa-undo"></i>
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body p-0">
            <div class="overlay text-center" v-if="is_loading">
              <img :src="getImage('logo.svg')" class="loader-img" alt="loader">
            </div>
            <div class="table-responsive">

              <table class="table">
                <thead>
                <tr>

                  <th style="width: 10px">
                    <input type="checkbox" v-model="is_selected_all" @click="selectedRowAll()">
                  </th>
                  <th>ID
                    <sort-icons :_sort="'id'"/>
                  </th>
                  <th>Username
                    <sort-icons :_sort="'username'"/>
                  </th>
                  <th>FullName
                    <sort-icons :_sort="'fullname'"/>
                  </th>
                  <th>Email
                    <sort-icons :_sort="'email'"/>
                  </th>
                  <th>Gender
                    <sort-icons :_sort="'gender'"/>
                  </th>
                  <th>DOB (YYYY-MM-DD)
                    <sort-icons :_sort="'date_of_birth'"/>
                  </th>
                  <th>NID
                    <sort-icons :_sort="'nid_number'"/>
                  </th>
                  <th>Expiry Date
                    <sort-icons :_sort="'expiration_date'"/>
                  </th>
                  <th>Step
                    <sort-icons :_sort="'step'"/>
                  </th>
                  <th>Status
                    <sort-icons :_sort="'status'"/>
                  </th>
                  <th>Comment
                    <sort-icons :_sort="'comment'"/>
                  </th>
                  <th>Country
                    <sort-icons :_sort="'country_id'"/>
                  </th>
                  <th>City
                    <sort-icons :_sort="'city_id'"/>
                  </th>
                  <th>CreateTime
                    <sort-icons :_sort="'created_at'"/>
                  </th>
                  <th class="text-right">Action</th>

                </tr>
                </thead>
                <tbody class="list">
                <tr v-for="(val, index) in list.data">

                  <td>
                    <input type="checkbox" v-model="selected_row" :value="val.id">
                  </td>
                  <td>{{ val.id }}</td>
                  <td>{{ !_.isEmpty(val.userinfo) ? val.userinfo.username : 'NA' }}</td>
                  <td>{{ !_.isEmpty(val.userinfo) ? val.userinfo.name : 'NA' }}</td>
                  <td>{{ !_.isEmpty(val.userinfo) ? val.userinfo.email : 'NA' }}</td>
                  <td>{{
                      !_.isEmpty(val.gender) ? val.gender.charAt(0).toUpperCase() + val.gender.slice(1) : 'NA'
                    }}
                  </td>
                  <td>{{ !_.isEmpty(val.date_of_birth) ? val.date_of_birth : 'NA' }}</td>
                  <td>{{ !_.isEmpty(val.nid_number) ? val.nid_number : 'NA' }}</td>
                  <td>{{ !_.isEmpty(val.expiration_date) ? val.expiration_date : 'NA' }}</td>
                  <td>{{ val.step !== undefined ? val.step : "1" }}</td>
                  <td>{{
                      !_.isEmpty(val.status) ? val.status.charAt(0).toUpperCase() + val.status.slice(1) : 'NA'
                    }}
                  </td>
                  <td>{{ !_.isEmpty(val.comment) ? val.comment : 'NA' }}</td>
                  <td>{{ !_.isEmpty(val.ewcountry_country_id) ? val.ewcountry_country_id.name : 'NA' }}</td>
                  <td>{{ !_.isEmpty(val.ewcity_city_id) ? val.ewcity_city_id.name : 'NA' }}</td>
                  <td>{{ customFormatter(val.created_at, 'lll') }}</td>
                  <td class="text-right">
                    <router-link v-if="actionView == true"
                                 :to="{ name: 'EWUserPendingDetailShow', params: { id: val.id }}"
                                 class="btn btn-info btn-sm m-2px">
                      <i class="fas fa-eye"></i>
                    </router-link>
                    <router-link v-if="actionEdit == true && checkEditPermission(val)"
                                 :to="{ name: 'EWUserPendingDetailEdit', params: { id: val.id }}"
                                 class="btn btn-info btn-sm m-2px">
                      <i class="fas fa-pencil-alt"></i>
                    </router-link>
                    <!--                  <a v-if="actionDelete == true && checkDeletePermission(val)" class="btn btn-danger btn-sm m-2px"
                                         href="javascript:void(0)" @click="deleteObject(val.id, index)"><i class="fas fa-trash"></i></a>-->
                  </td>

                </tr>
                </tbody>
              </table>
            </div>
            <div class="p-4" v-if="empty==true && is_loading == false">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>


          <div class="card-footer">
            <vue-pagination
                :pagination="list"
                v-if="list.total > list.per_page"
                @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>

  </div>
</template>

<script>
import VuePagination from '@/components/partials/PaginationComponent'
import SortIcons from '@/components/utils/SortIcons'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import {CommonAPI, PermissionChecker} from '@/services/api'
import {mapGetters, mapActions} from 'vuex'
import {Notification} from 'element-ui'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const fileDownload = require('js-file-download')


export default {
  name: 'EWUserPendingDetail',
  metaInfo: {
    title: 'User Pending Details | Dotlines'
  },
  components: {
    DatePicker, VuePagination, SortIcons
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1
    },
    actionCreate: false,
    actionView: true,
    actionEdit: true,
    actionDelete: true,
    api_url: '',
    showFilter: false,
    filter: {
      country_id: null,
      city_id: null

    },
    dateRange: '',
    pre: [],
    is_loading: false,
    empty: false,
    empty_message: '',
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
    // selectedCountry: null,
    // selectedCity: null,
    countries: [],
    cities: [],
    allCities: [],
  }),
  mounted: function () {
    this.is_loading = true
    this.getCountries()
    this.getCities()
    if (this.isMobile()) {
      //window.$(document).find('.push-menu-class').trigger('click');
      window.$("body").removeClass("sidebar-open")
      window.$("body").addClass("sidebar-closed sidebar-collapse")
    }
    this.api_url = '/ew_user_pending_details'
    this.initialize()
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon')
      this.reload()
    });
  },
  computed: {
    ...mapGetters(['profile'])
  },
  methods: {
    customFormatter(date, format = 'MMM Do YY, h:mm:ss a') {
      return moment(date).format(format);
    },
    async initialize() {
      this.is_loading = true
      // eslint-disable-next-line no-undef
      if (_.isEmpty(this.profile)) {
        // eslint-disable-next-line camelcase
        await CommonAPI.getProfile().then(profile_info => {
          // eslint-disable-next-line camelcase
          this.user_detail = profile_info
        })
      } else {
        this.user_detail = this.profile
      }

      await CommonAPI.getCustomPermission('/get-custom-permission-infos?path=api/ew_user_pending_details').then(response => {
        // eslint-disable-next-line eqeqeq
        if (response.status == 200) {
          this.custom_permission_data = response.data
        }
      });

      // eslint-disable-next-line no-undef
      if (!_.isEmpty(this.custom_permission_data)) {
        this.actionCreate = true
        /*this.actionCreate = await PermissionChecker.checkCreateButtonPermission(this.custom_permission_data.action_permission,
          this.custom_permission_data['create_id_condition'], this.user_detail, this.custom_permission_data.enableAdministratorPermissionByDefault)*/
      }

      await this.getList().then(response => {
        this.list = response.data
        this.is_loading = false
      }).catch(error => {
        this.empty = true
        if (error.response.status === 403) {
          this.has_permission = false
        }
        this.is_loading = false
      });

    },
    async getFilterData() {
      this.is_loading = true
      await this.getList().then(response => {
        this.list = response.data
        this.is_loading = false
      }).catch(error => {
        this.empty = true
        if (error.response.status === 403) {
          this.has_permission = false
        }
        this.is_loading = false
      })

    },
    reload: function () {
      this.is_loading = true
      this.getList().then(response => {
        this.list = response.data
        this.is_loading = false
      }).catch(error => {
        this.empty = true
        if (error.response.status === 403) {
          this.has_permission = false
        }
        this.is_loading = false
      })
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        /* let params = {page: this.list.current_page}
        params = {...this.filter, ...this.$route.query, ...params} */
        const params = {...this.filter, ...this.$route.query}
        axios.get(this.api_url, {
          params: params
        }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
          //console.log("error", error.response.data);
        }).finally(() => {
          //_this.is_loading = false;
        })
      })
    },
    checkEditPermission: function (data) {
      // eslint-disable-next-line no-undef
      return this.checkRole()
      /*if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(this.custom_permission_data.action_permission, this.custom_permission_data['edit_id_condition'],
          this.custom_permission_data['edit_refid_condition'], this.custom_permission_data['edit_custom_condition'], data, this.user_detail, this.custom_permission_data.enableAdministratorPermissionByDefault, this.custom_permission_data['operator_between_block_condition_rules'])
      } else {
        return false
      }*/
    },
    checkDeletePermission: function (data) {
      // eslint-disable-next-line no-undef
      return this.checkRole()
      /*if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(this.custom_permission_data.action_permission, this.custom_permission_data['delete_id_condition'],
          this.custom_permission_data['delete_refid_condition'], this.custom_permission_data['delete_custom_condition'], data, this.user_detail, this.custom_permission_data.enableAdministratorPermissionByDefault, this.custom_permission_data['operator_between_block_condition_rules'])
      } else {
        return false
      }*/
    },
    async checkRole() {
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then(profile_info => {
          this.user_detail = profile_info
        })
      } else {
        this.user_detail = this.profile
      }
      const allowedRoles = this.VUE_APP_USER_LIST_ALLOWED_ROLES.split(',').map(role => parseInt(role, 10));
      let userRole = this.user_detail.roles[0].id;
      return allowedRoles.includes(userRole);
    },
    async resetFilter() {
      this.list.current_page = 1
      this.filter = {}
      this.is_loading = true
      await this.getList().then(response => {
        this.list = response.data
      }).catch(error => {
        this.empty = true

        if (error.response.status === 403) {
          this.has_permission = false
        }
      })
      this.is_loading = false
    },
    deleteObject: function (id, index) {
      const _this = this
      let delete_api_url = '/ew_user_pending_details/' + id

      _this.$swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          _this.is_loading = true
          axios.delete(delete_api_url)
              .then(response => {
                _this.list.data.splice(index, 1)
                _this.$toaster.success(response.data.message)
                _this.is_loading = false
              })
              .catch(error => {
                _this.is_loading = false
                console.log(error)
                _this.$swal.fire(
                    "Failed!",
                    "failed to delete.",
                    "error"
                )
              })
              .finally(() => {
                _this.is_loading = false
              });
        }
      });
    },
    exportFile: function () {
      this.is_loading = true
      axios.get("/ew-user-details-export", {responseType: "blob"})
          .then(response => {
            fileDownload(response.data, "user_pending_details.xlsx")
          })
          .catch((error) => {
            console.log('error ' + error)
          })
          .finally(() => {
            this.is_loading = false
            Notification.success({
              title: 'Export Completed',
              message: 'Export operation completed successfully',
              type: 'success'
            })
          });
    },
    getCountries: function () {
      this.is_loading = true
      axios.get("/get-countries")
          .then(response => {
            // console.log('response', response)
            this.countries = response.data
          })
          .catch((error) => {
            console.log('error ' + error)
          })
          .finally(() => {
            this.is_loading = false
          });
    },
    getCities: function () {
      this.is_loading = true
      axios.get("/get-cities")
          .then(response => {
            //console.log('getCities response', response)
            this.cities = response.data
            this.allCities = response.data
          })
          .catch((error) => {
            console.log('error ' + error)
          })
          .finally(() => {
            this.is_loading = false
          });
    },
    updateCityList: function (e) {

      // console.log('selectedCountry', e)
      this.cities = []
      this.filter.city_id = null
      this.allCities.forEach((item) => {
        if (item.country_id === this.filter.country_id) {
          this.cities.push(item)
        }
      })

    },
    selectedRowAll: function () {
      let isSelectedAll = this.is_selected_all = !this.is_selected_all
      if (isSelectedAll) {
        var items = []
        this.list.data.forEach(function (item) {
          items.push(item.id)
        })
        this.selected_row = items
      } else {
        this.selected_row = []
      }
    },
    handleSelectedRows(command) {
      if (command === 'delete') {
        axios({
          method: 'delete',
          url: '/ew_user_pending_details/delete-all',
          data: {'ids': this.selected_row},
          headers: {'Content-Type': 'application/json'},
        }).then(function (response) {
          Notification.success({title: 'Deleted Successfully', message: 'Data deleted successfully', type: 'success'})
          this.initialize()
        }).catch((errors) => {
          // eslint-disable-next-line no-undef
          if (!_.isEmpty(errors.response) && errors.response.status === 500) {
            this.$toaster.error(errors.response.data.message)
          }
        }).finally(() => {
          this.is_selected_all = false
          this.initialize()
        });
      }
    },

  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
